import { gql } from 'graphql-request';
import { formLayout, casesRecent } from '../../../graphql/queries';

export const GET_OPEN_TICKETS = gql`
  query ListCases($locationNum: String!, $contactGuid: String, $page: Int) {
    openCases(
      locationNum: $locationNum
      contactGuid: $contactGuid
      page: $page
    ) {
      pageInfo {
        totalItems
        totalPages
        hasNextPage
      }
      cases {
        id
        number
        status
        description
        contact {
          audience
          fullName
          guid
        }
        updatedOn
        isUnread
        locationNum
        canRequestUpdate
        confidential
      }
    }
  }
`;

export const GET_OPEN_TICKETS_BY_USER = gql`
  query ListCases($locationNum: String!, $user: String, $page: Int) {
    openCases(locationNum: $locationNum, contactGuid: $user, page: $page) {
      pageInfo {
        totalItems
        totalPages
        hasNextPage
      }
      cases {
        id
        number
        status
        description
        contact {
          audience
          fullName
          guid
        }
        assignedTo {
          firstName
          audience
          photoURL
          fullName
        }
        updatedOn
        isUnread
        locationNum
        canRequestUpdate
        confidential
      }
    }
  }
`;

export const GET_CLOSED_TICKETS = gql`
  query ListCases($locationNum: String!, $page: Int) {
    closedCases(locationNum: $locationNum, page: $page) {
      pageInfo {
        totalItems
        totalPages
        hasNextPage
      }
      cases {
        id
        number
        status
        description
        contact {
          audience
          fullName
          guid
        }
        assignedTo {
          firstName
          audience
          photoURL
          fullName
        }
        updatedOn
        isUnread
        locationNum
        canRequestUpdate
        confidential
      }
    }
  }
`;

export const GET_ALL_TICKETS = gql`
  query ListCases($locationNum: String!, $page: Int) {
    cases(locationNum: $locationNum, page: $page) {
      pageInfo {
        totalItems
        totalPages
        hasNextPage
      }
      cases {
        id
        number
        status
        description
        contact {
          audience
          fullName
          guid
        }
        assignedTo {
          firstName
          audience
          photoURL
          fullName
        }
        updatedOn
        isUnread
        locationNum
        canRequestUpdate
        confidential
      }
    }
  }
`;

export const GET_TICKET_LOCATION_BY_ID = gql`
  query GetCase($id: ID!, $markRead: Boolean) {
    case(id: $id, markRead: $markRead) {
      locationNum
    }
  }
`;

export const GET_TICKET_BY_ID = gql`
  query GetCase($id: ID!, $markRead: Boolean) {
    case(id: $id, markRead: $markRead) {
      id
      number
      status
      description
      longDescription
      isUnread
      promptTypes
      confidential
      description
      longDescription
      closedOn
      willCloseOn
      openedOn
      canRequestUpdate
      assignedTo {
        firstName
        lastName
        fullName
        guid
        audience
        photoURL
      }
      contact {
        firstName
        lastName
        fullName
        guid
      }
      openedOn
      locationNum
      isUnread
      promptTypes
      assignedTo {
        id
        firstName
        lastName
        guid
        audience
        photoURL
      }
      contact {
        firstName
        lastName
        fullName
        guid
      }
      requestedItem {
        number
        id
      }
      submissionDetails {
        value
        label
      }
      activityStream {
        __typename
        id
        caseId
        text
        createdBy {
          __typename
          id
          firstName
          lastName
          fullName
          guid
          audience
          photoURL
        }
        createdOn
        ... on ActivityStreamAttachment {
          downloadURL
          fileName
          mimeType
        }
        ... on ActivityStreamComment {
          translatedText
        }
      }
    }
  }
`;

export const GET_LOCATION = gql`
  query getLocation($locationNum: String!) {
    restaurant(locationNum: $locationNum) {
      id
      number
      name
      supportDeskPhoneNumber
      siteProperties {
        lat
        long
        countryCode
      }
      operator {
        fullName
        photoURL
        email
      }
      contacts {
        id
        guid
        firstName
        fullName
        lastName
        audience
        photoURL
      }
    }
  }
`;

export const GET_STAFF_LOCATIONS = gql`
  query StaffLocations($guid: String!) {
    restaurantsStaff(userGuid: $guid) {
      type
      restaurants {
        number
        name
        openCasesCount
      }
    }
  }
`;

export const GET_ALL_LOCATIONS = gql`
  query MyQuery {
    restaurants {
      number
      name
    }
  }
`;

export const GET_CLOSE_REASONS = gql`
  query GetKBFeedbackReasons {
    closeCaseReasons {
      label
      value
    }
  }
`;

export const GET_APPOINTMENTS = gql`
  query GetAppointments($locationNums: [String]) {
    appointments(locationNums: $locationNums) {
      id
      dueDate
      subject
      status
      restaurant {
        number
        name
        siteProperties {
          lat
          long
          utcOffset
          tzId
        }
      }
    }
  }
`;

export const GET_APPOINTMENT_DETAILS = gql`
  query GetAppointment($id: ID!) {
    appointment(id: $id) {
      id
      dueDate
      subject
      description
      contact
      status
      caseNumber
      technician {
        id
        firstName
        lastName
        fullName
        guid
        audience
        photoURL
        photo
        title
        mobilePhone
      }
      restaurant {
        number
        name
        siteProperties {
          lat
          long
          utcOffset
          tzId
        }
      }
    }
  }
`;

export const GET_ANNOUNCEMENTS = gql`
  query GetAnnouncements {
    announcements {
      category
      id
      summary
      title
      updatedOn
      hasBeenUpdated
      url
      majorCaseId
      isExpired
      isUnread
      outagePageURL
    }
  }
`;
export const GET_SUPPORT_CATEGORIES = gql`
  query GetSupportCategories {
    supportCategories {
      id
      label
      imageName
      url
      items {
        id
        featuredOrder
        recentlyFeaturedOrder
        commonlyUsedOrder
        recommendedOrder
        label
        description
        imageName
        url
        form {
          id
          minimumAppVersion
          introContents {
            header
            body {
              text
              imageName
            }
          }
          showIntroOnLoad
        }
        items {
          id
          featuredOrder
          recentlyFeaturedOrder
          commonlyUsedOrder
          recommendedOrder
          label
          description
          imageName
          url
          form {
            id
            minimumAppVersion
            introContents {
              header
              body {
                text
                imageName
              }
            }
            showIntroOnLoad
          }
        }
      }
    }
  }
`;

export const GET_SUPPORT_CATEGORY_ITEM = gql`
  query GetSupportCategoryItem($id: ID!) {
    supportCategoryItem(id: $id) {
      id
      label
      description
      imageName
      url
      form {
        id
        minimumAppVersion
        introContents {
          header
          body {
            text
            imageName
          }
        }
        showIntroOnLoad
      }
      featuredOrder
      commonlyUsedOrder
      recentlyFeaturedOrder
      recommendedOrder
    }
  }
`;

export const GET_FORM_LAYOUT = gql`
  ${formLayout}
`;

export const SEARCH_ALL_SUPPORT = gql`
  query Search(
    $contains: String!
    $context: [SupportSearchContext]
    $ignoreTrackSearch: Boolean
  ) {
    searchAllSupport(
      contains: $contains
      context: $context
      ignoreTrackSearch: $ignoreTrackSearch
    ) {
      articles {
        id
        number
        title
        visibility
        solutionContent
        searchQueryId
        searchResultId
      }
      forms {
        id
        label
        description
        imageName
        url
        form {
          id
          minimumAppVersion
          introContents {
            header
            body {
              text
              imageName
            }
          }
          showIntroOnLoad
        }
      }
      searchResultCases {
        id
        number
        status
        description
        longDescription
        commentPreview
        openedOn
        updatedOn
        confidential
        locationNum
        contact {
          id
          guid
          fullName
          firstName
          lastName
        }
        __typename
      }
    }
  }
`;

export const GET_SECURE_SNOW_URL = gql`
  query GetNewServiceNowLink($link: String!) {
    secureServiceNowLink(unsecureLink: $link)
  }
`;

export const GET_RELATED_MINOR_CASES = gql`
  query ListRelatedCases($caseId: ID!) {
    relatedCases(majorCaseId: $caseId) {
      id
      number
      ... on MinorCaseType {
        locationNum
      }
    }
  }
`;

export const GET_KB_ARTICLE = gql`
  query GetKBArticle(
    $id: ID!
    $trackView: Boolean
    $foundViaQueryId: ID
    $foundViaResultId: ID
  ) {
    kbArticle(
      id: $id
      trackView: $trackView
      foundViaQueryId: $foundViaQueryId
      foundViaResultId: $foundViaResultId
    ) {
      id
      number
      title
      visibility
      solutionContent
    }
  }
`;

export const GET_RECENT_SEARCHES = gql`
  query GetRecentSearches($userGuid: String!) {
    searchesRecent(userGuid: $userGuid)
  }
`;

export const GET_HELPFUL_RECENT_KB_ARTICLES = gql`
  query GetKBArticles {
    kbArticlesAnswers {
      articlesFeatured {
        id
        number
        title
      }
      articlesRecent {
        id
        number
        title
      }
    }
  }
`;

export const GET_KB_FEEDBACK_REASONS = gql`
  query GetKBFeedbackReasons {
    kbFeedbackReasons {
      label
      value
    }
  }
`;

export const GET_ASSETS = gql`
  query GetAssets($locationNums: [String]!, $csiCode: String) {
    assets(locationNums: $locationNums, csiCode: $csiCode) {
      id
      tag
      serial
      csiCode
      name
      locationNum
      department
      type {
        id
        name
        family
      }
      model {
        id
        imageURL
        allowAdditionalEquipmentRequest
      }
      manufacturer
      relatedCases {
        id
        number
        ... on AssetCaseType {
          description
        }
      }
      flowInfos {
        flowId
        flowName
        title
        description
        thumbnailImageURL
        minimumAppVersion
        __typename
      }
    }
  }
`;

export const GET_RECENT_ASSETS = gql`
  query RecentAssets($guid: String!) {
    assetsRecent(userGuid: $guid) {
      id
      tag
      serial
      locationNum
      viewedOn
    }
  }
`;

export const GET_ASSET_RESOURCES = gql`
  query GetResources($locationNum: String!) {
    assetResources(locationNum: $locationNum) {
      key
      externalURL
      imageName
      label
    }
  }
`;

export const GET_SUPPORT_CATEGORIES_ASSET = gql`
  query GetSupportCategories($context: SupportCategoryContext) {
    supportCategoriesAsset(context: $context) {
      id
      label
      description
      imageName
      url
      form {
        id
        minimumAppVersion
        introContents {
          header
          body {
            text
            imageName
          }
        }
        showIntroOnLoad
        defaults {
          id
          value
        }
      }
    }
  }
`;

export const GET_AIRSHIP_USER_PROPERTIES = gql`
  query GetAirshipUserProperties($guid: String) {
    airshipUserProperties(namedUserGuid: $guid) {
      attributes {
        label
        value
      }
      tagGroups {
        name
        tags
      }
    }
  }
`;

export const GET_CASE_PROMPTS = gql`
  query GetCasePrompts($caseId: ID!, $promptTypes: [CasePromptType]) {
    casePrompts(caseId: $caseId, promptTypes: $promptTypes) {
      __typename
      id
      promptType
      title
      description
      ... on CasePromptViewAppointment {
        appointmentId
      }
    }
  }
`;

export const GET_ASSET_WARRANTIES = gql`
  query GetAssetWarranties($assetId: ID!) {
    assetWarranties(assetId: $assetId) {
      id
      type
      name
      status
      expiresOn
      termMonths
      coverage {
        header
        body
      }
    }
  }
`;

export const GET_USER_EVENT_INFO = gql`
  query GetUserEventInfo($eventType: String!, $filter: UserEventFilter) {
    userEventInfo(eventType: $eventType, filter: $filter) {
      userGuid
      eventType
      count
    }
  }
`;

export const GET_TROUBLESHOOTING_FLOWS = gql`
  query GetTroubleshootingFlows($locationNum: String!) {
    flowInfos(locationNum: $locationNum) {
      flowId
      flowName
      title
      description
      minimumAppVersion
      thumbnailImageURL
    }
  }
`;

export const GET_TROUBLESHOOTING_FLOW = gql`
  query Flow($flowId: String!, $assetId: String, $locationNum: String) {
    flow(flowId: $flowId, assetId: $assetId, locationNum: $locationNum) {
      id
      name
      shortName
      startStepId
      steps {
        id
        instructions {
          id
          instructionType
          variesBasedOn
          variants {
            key
            changes {
              visible
              optional
              options {
                label
                supportingLabels
                value
                filterSets
                matches
                hiddenMatches
                __typename
              }
              __typename
            }
            __typename
          }

          ... on KBArticleFlowInstruction {
            kbNumber
            title
          }
          ... on ImageFlowInstruction {
            imageURL
          }
          ... on InputFlowInstruction {
            label
            flowVariableId
            optional
            keyboard
            minLines
            maxLines
            footer
            placeholder
            summaryPolicy {
              template
              default
              __typename
            }
          }
          ... on DisplayTextFlowInstruction {
            header
            content
          }
          ... on SingleSelectInputFlowInstruction {
            label
            flowVariableId
            options {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            summaryPolicy {
              mappings {
                matchFlowVariableValue
                message
                __typename
              }
              __typename
            }
          }
          ... on SpacingFlowInstruction {
            spacingType
          }
          ... on LocationPickerInputFlowInstruction {
            flowVariableId
            locationPickerLabel
            footer
          }
          ... on TicketContactPickerInputFlowInstruction {
            flowVariableId
            variesByFlowVariableId
            ticketContactPickerLabel
            footer
          }
          ... on SelectSearchInputFlowInstruction {
            flowVariableId
            label
            showLabelInline
            placeholderText
            footer
            options {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            otherOption {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            searchHeader
            searchPlaceholderText
            filters {
              label
              subLabel
              keyword
              sortStrategy
              __typename
            }
            sortStrategy
            optional
            visible
            summaryPolicy {
              mappings {
                matchFlowVariableValue
                message
                __typename
              }
              __typename
            }
          }
          ... on IconFlowInstruction {
            symbol
            color
            footer
          }
          ... on SummaryInputFlowInstruction {
            flowVariableId
            label
            detailsInput {
              label
              minLines
              maxLines
              placeholder
              footer
              optional
              __typename
            }
          }
          ... on RestartButtonFlowInstruction {
            text
            style
          }
          ... on AttachmentInputFlowInstruction {
            label
            placeholder
            footer
            maxAttachments
            optional
          }
          ... on MultiSelectInputFlowInstruction {
            label
            flowVariableId
            options {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            optional
            summaryPolicy {
              template
              mappings {
                matchFlowVariableValue
                message
                __typename
              }
              __typename
            }
          }
          ... on FormButtonFlowInstruction {
            text
            style
            formId
            formDefaultMappings {
              formVariableId
              flowVariableId
              literalValue
              __typename
            }
            formDefaultSummaryId
          }
          ... on CloseButtonFlowInstruction {
            text
            style
          }
          ... on AssetTagGraphicFlowInstruction {
            tagNumber
            state
            assetTagGraphicLabel
          }
          ... on EquipmentInfoFlowInstruction {
            equipmentInfoLabel
            modelCategoryName
            modelNumber
            manufacturer
            serial
          }
          ... on AssetTagInputFlowInstruction {
            flowVariableId
            assetTagInputTitle
            assetTagInputLabel
            placeholder
            summaryPolicy {
              template
              default
              __typename
            }
          }
        }
        mustBranchDynamically
        staticBranches {
          id
          matchConditions {
            flowVariableId
            matchingValue
            __typename
          }
          nextStepId
          __typename
        }
        branchLabelOverride
        isBacktrackDisabled
        formToSubmit {
          formId
          formVariableMappings {
            formVariableId
            flowVariableId
            literalValue
            __typename
          }
          formSummaryMapping {
            formVariableId
            flowVariableId
            literalValue
            __typename
          }
          successMessage
          __typename
        }
        heroImageURL
        defaults {
          id
          value
          __typename
        }
        __typename
      }
      defaults {
        id
        value
        __typename
      }
      __typename
    }
  }
`;

export const GET_TROUBLESHOOTING_FLOW_NEXT_STEP = gql`
  query NextFlowStep(
    $flowId: String!
    $currStepId: String
    $inputs: [FlowVariableInput]!
    $locationNum: String
  ) {
    nextFlowStep(
      flowId: $flowId
      currStepId: $currStepId
      inputs: $inputs
      locationNum: $locationNum
    ) {
      id
      instructions {
        id
        instructionType
        variesBasedOn
        variants {
          key
          changes {
            visible
            optional
            options {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            __typename
          }
          __typename
        }

        ... on KBArticleFlowInstruction {
          kbNumber
          title
        }
        ... on ImageFlowInstruction {
          imageURL
        }
        ... on InputFlowInstruction {
          label
          flowVariableId
          optional
          keyboard
          minLines
          maxLines
          footer
          placeholder
          summaryPolicy {
            template
            default
            __typename
          }
        }
        ... on DisplayTextFlowInstruction {
          header
          content
        }
        ... on SingleSelectInputFlowInstruction {
          label
          flowVariableId
          options {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          summaryPolicy {
            mappings {
              matchFlowVariableValue
              message
              __typename
            }
            __typename
          }
        }
        ... on SpacingFlowInstruction {
          spacingType
        }
        ... on LocationPickerInputFlowInstruction {
          flowVariableId
          locationPickerLabel
          footer
        }
        ... on TicketContactPickerInputFlowInstruction {
          flowVariableId
          variesByFlowVariableId
          ticketContactPickerLabel
          footer
        }
        ... on SelectSearchInputFlowInstruction {
          flowVariableId
          label
          showLabelInline
          placeholderText
          footer
          options {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          otherOption {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          searchHeader
          searchPlaceholderText
          filters {
            label
            subLabel
            keyword
            sortStrategy
            __typename
          }
          sortStrategy
          optional
          visible
          summaryPolicy {
            mappings {
              matchFlowVariableValue
              message
              __typename
            }
            __typename
          }
        }
        ... on IconFlowInstruction {
          symbol
          color
          footer
        }
        ... on SummaryInputFlowInstruction {
          flowVariableId
          label
          detailsInput {
            label
            minLines
            maxLines
            placeholder
            footer
            optional
            __typename
          }
        }
        ... on RestartButtonFlowInstruction {
          text
          style
        }
        ... on AttachmentInputFlowInstruction {
          label
          placeholder
          footer
          maxAttachments
          optional
        }
        ... on MultiSelectInputFlowInstruction {
          label
          flowVariableId
          options {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          optional
          summaryPolicy {
            template
            mappings {
              matchFlowVariableValue
              message
              __typename
            }
            __typename
          }
        }
        ... on FormButtonFlowInstruction {
          text
          style
          formId
          formDefaultMappings {
            formVariableId
            flowVariableId
            literalValue
            __typename
          }
          formDefaultSummaryId
        }
        ... on CloseButtonFlowInstruction {
          text
          style
        }
        ... on AssetTagGraphicFlowInstruction {
          tagNumber
          state
          assetTagGraphicLabel
        }
        ... on EquipmentInfoFlowInstruction {
          equipmentInfoLabel
          modelCategoryName
          modelNumber
          manufacturer
          serial
        }
        ... on AssetTagInputFlowInstruction {
          flowVariableId
          assetTagInputTitle
          assetTagInputLabel
          placeholder
          summaryPolicy {
            template
            default
            __typename
          }
        }
      }
      mustBranchDynamically
      staticBranches {
        id
        matchConditions {
          flowVariableId
          matchingValue
          __typename
        }
        nextStepId
        __typename
      }
      branchLabelOverride
      isBacktrackDisabled
      formToSubmit {
        formId
        formVariableMappings {
          formVariableId
          flowVariableId
          literalValue
          __typename
        }
        formSummaryMapping {
          formVariableId
          flowVariableId
          literalValue
          __typename
        }
        successMessage
        __typename
      }
      heroImageURL
      defaults {
        id
        value
        __typename
      }
      __typename
    }
  }
`;

export const GET_MEMBERSHIPS = gql`
  query GetMemberships($locationNums: [String], $guid: String) {
    programMemberships(locationNums: $locationNums, userGuid: $guid) {
      locationMemberships {
        program
        locationNum
      }
      userMemberships {
        program
        guid
      }
    }
  }
`;

export const GET_ASSET_SERVICE_HISTORY = gql`
  query AssetServiceHistory($assetId: ID!, $locationNum: String!) {
    assetServiceHistory(assetId: $assetId, locationNum: $locationNum) {
      assetId
      locationNum
      events {
        id
        assetId
        locationNum
        status
        costUSD
        serviceDate
        issue
        resolution
        technicianName
        source
        vendor
        createdOn
        createdBy {
          fullName
        }
        updatedOn
        updatedBy {
          fullName
        }
        __typename
      }
      totalCostUSD
      __typename
    }
  }
`;

export const GET_SUPPORT_APP_CONFIG = gql`
  query GetSupportAppConfig {
    supportAppConfig {
      label
      value
    }
  }
`;

export const SEARCH_TICKETS = gql`
  query SearchCases($contains: String!, $filters: SearchCaseFilters) {
    searchCases(contains: $contains, filters: $filters) {
      id
      number
      status
      description
      longDescription
      commentPreview
      openedOn
      updatedOn
      confidential
      locationNum
      contact {
        id
        fullName
        guid
      }
      __typename
    }
  }
`;

export const facilityCategories = gql`
  query FacilityCategories {
    facilityCategories {
      type
      label
      order
      getSupportURL
      matches
      __typename
    }
  }
`;

export const GET_ASSET_SERVICE_EVENT = gql`
  query AssetServiceEvent($eventId: ID!) {
    assetServiceEvent(eventId: $eventId) {
      id
      assetId
      locationNum
      status
      costUSD
      serviceDate
      issue
      resolution
      technicianName
      source
      vendor
      createdOn
      updatedOn
      attachments {
        id
        fileName
        mimeType
        downloadUrl
        scheme
        __typename
      }
      __typename
    }
  }
`;

export const GET_CASES_RECENT = gql`
  ${casesRecent}
`;
